import { ConfirmUnsaved } from "components/ConfirmDialog/ConfirmUnsaved";
import { HookFormDebug } from "components/FormDebug/HookFormDebug";
import { EditFormFooter } from "components/Forms/EditFormFooter";
import { SlidingPanel } from "components/SlidingPanel/SlidingPanel";
import { useEditMeeting, useTranslations } from "providers";
import React from "react";

import { EditMeetingForm } from "./EditMeetingForm";

export const EditMeetingPanel: React.FC = () => {
  const i18n = useTranslations();
  const {
    confirmMeetingUnsaved,
    setConfirmMeetingUnsaved,
    editMeetingId,
    isDirty,
    isValid,
    isSubmittable,
    isSubmitting,
    getPatch,
    handleSave,
    handleClose,
    form,
  } = useEditMeeting();

  if (editMeetingId === -1) {
    return null;
  }

  const saveButtonDisabled = !isDirty || !isValid;

  return (
    <>
      <SlidingPanel
        isOpen={true}
        onCancel={() => handleClose(true)}
        onSave={() => handleSave()}
        onClose={() => handleClose()}
        panelClassName="edit-meeting-panel panel-form"
        panelContainerClassName=""
        saveButtonDisabled={saveButtonDisabled}
        isSubmitting={isSubmitting}
        size={50}
        debugContent={
          <HookFormDebug
            watch={() => getPatch(form.watch())}
            formState={form.formState}
            isSubmitting={isSubmitting}
            isSubmittable={isSubmittable}
          />
        }
        header={<h1>{i18n.EditMeetingPanel_Header}</h1>}
        footer={
          <EditFormFooter
            onCancel={() => handleClose(true)}
            onSubmit={() => handleSave()}
            isSubmitting={isSubmitting}
            isDirty={isDirty}
          />
        }
      >
        <EditMeetingForm />
      </SlidingPanel>

      <ConfirmUnsaved
        onAccept={() => handleClose(true)}
        isOpen={confirmMeetingUnsaved}
        setIsOpen={setConfirmMeetingUnsaved}
        onCancel={() => setConfirmMeetingUnsaved(false)}
      />
    </>
  );
};
